import React from "react";
import SiderMenu from "./SiderMenu";

export default props => <SiderMenu {...props} />;
